import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllOrdersResponse,
  getOrdersByIdResponse,
  getPendingOrdersResponse,
  getPackedOrdersResponse,
  getShippedOrdersResponse,
  getDeliveredOrdersResponse,
  getCancelledOrdersResponse,
  getOrdersByCustomerIdResponse,
  addProductIdToWishlistResponse,
  getOrdersByCartBundleIdResponse,
  getTotalSalesResponse,
  getTotalOrdersResponse,
  getPendingCountResponse,
  getDeliveredCountResponse,
  getPackedCountResponse,
  getShippedCountResponse,
  getCancelledCountResponse,
  getCartBundleIdOrdersResponse,
  getCustomerTotalOrdersQuantityResponse,
  getAllOrdersByCartBundleIdResponse,
  getAllCompletedOrdersByCartBundleResponse,
} from "../actions";

export function* createOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`orders`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Orders saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateOrdersEffectSaga(action) {
  try {
    console.log("order update", action);
    const { data } = yield call(() =>
      axiosPut(`orders/${action?.data?.payload?.id}`, action.data?.payload)
    );
    yield put(getPendingOrdersResponse(data));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Order Status Changed Successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/all`));
    yield put(getAllOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllOrdersResponse([]));
  }
}

export function* getOrdersByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/1`));
    yield put(getOrdersByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getOrdersByIdResponse([]));
  }
}

export function* deleteOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`orders/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Orders deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getPendingOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/pending`));
    yield put(getAllOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllOrdersResponse([]));
  }
}

export function* getPackedOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/packed`));
    yield put(getPackedOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getPackedOrdersResponse([]));
  }
}

export function* getTotalSalesEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/totalSales`));
    console.log(data);
    // yield put(getPackedOrdersResponse(data));
    yield put(getTotalSalesResponse({ totalSales: data }));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    action?.payload?.callback?.failure?.(e);
    yield put(getTotalSalesResponse({ totalSales: 0 }));
  }
}
export function* getTotalOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/totalOrders`));
    console.log(data);
    yield put(getTotalOrdersResponse({ totalOrders: data }));

    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    action?.payload?.callback?.failure?.(e);
    yield put(getTotalOrdersResponse({ totalOrders: 0 }));
  }
}
export function* getPendingCountEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/pendingCount`));
    console.log(data);
    yield put(getPendingCountResponse({ pendingCount: data }));

    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getPendingCountResponse({ pendingCount: 0 }));
  }
}

export function* getDeliveredCountEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/deliveredCount`));
    console.log(data);
    yield put(getDeliveredCountResponse({ deliveredCount: data }));

    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getDeliveredCountResponse({ deliveredCount: 0 }));
  }
}

export function* getPackedCountEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/packedCount`));
    console.log(data);
    yield put(getPackedCountResponse({ packedCount: data }));

    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getPackedCountResponse({ packedCount: 0 }));
  }
}

export function* getShippedCountEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/shippedCount`));
    console.log(data);
    yield put(getShippedCountResponse({ shippedCount: data }));

    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getShippedCountResponse({ shippedCount: 0 }));
  }
}

export function* getCancelledCountEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/cancelledCount`));
    console.log(data);
    yield put(getCancelledCountResponse({ cancelledCount: data }));

    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCancelledCountResponse({ cancelledCount: 0 }));
  }
}

export function* getShippedOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/shipped`));
    yield put(getShippedOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getShippedOrdersResponse([]));
  }
}

export function* getDeliveredOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/delivered`));
    yield put(getDeliveredOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getDeliveredOrdersResponse([]));
  }
}

export function* getCancelledOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/cancelled`));
    yield put(getCancelledOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCancelledOrdersResponse([]));
  }
}

export function* getOrdersByCustomerIdEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`orders/customer/${action?.payload?.id}`)
    );
    yield put(getAllOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllOrdersResponse([]));
  }
}

export function* addProductIdToWishlistEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`customer/wishlist/add?customerId=1&productId=2`)
    );
    yield put(addProductIdToWishlistResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(addProductIdToWishlistResponse([]));
  }
}

export function* createOrdersWithProductsEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(
        `orders/products?productId=1&customerId=7&quantity=2&addressId=3`,
        action.data?.payload
      )
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Orders saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getOrdersByCartBundleIdEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`orders/cart-bundle/${action?.payload?.id}`)
    );
    yield put(getOrdersByCartBundleIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getOrdersByCartBundleIdResponse([]));
  }
}

export function* getCartBundleIdOrdersEffectSaga(action) {
  const { id } = action?.payload;
  try {
    const { data } = yield call(() => axiosGet(`orders/byCartBundle/${id}`));
    yield put(getCartBundleIdOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCartBundleIdOrdersResponse({}));
  }
}

export function* getCustomersTotalOrdersQuantityEffectSaga(action) {
  const { id } = action?.payload;
  try {
    const { data } = yield call(() =>
      axiosGet(`orders/total-qty-by-customer/${id}`)
    );
    yield put(getCustomerTotalOrdersQuantityResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCustomerTotalOrdersQuantityResponse([]));
  }
}

export function* getAllOrdersByCartBundleIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`orders/allByCartBundle`));
    console.log("data", data);
    yield put(getAllOrdersByCartBundleIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllOrdersByCartBundleIdResponse([]));
  }
}

export function* getAllCompletedOrdersEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`orders/completed/allCartBundle`)
    );
    console.log("data", data);
    yield put(getAllCompletedOrdersByCartBundleResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllCompletedOrdersByCartBundleResponse([]));
  }
}

export function* updateOrderStatusByCartBundleIdEffectSaga(action) {
  const { id, status } = action?.payload;
  try {
    const { data } = yield call(() =>
      axiosGet(`orders/update-status?cartBundleId=${id}&status=${status}`)
    );
    yield put(getCartBundleIdOrdersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
  }
}

export function* ordersWatcherSaga() {
  yield takeLatest(types.CREATE_ORDERS, createOrdersEffectSaga);
  yield takeLatest(types.UPDATE_ORDERS, updateOrdersEffectSaga);
  yield takeLatest(types.GET_ALL_ORDERS, getAllOrdersEffectSaga);
  // yield takeLatest(types.GET_ORDERS, getOrdersByIdEffectSaga);
  yield takeLatest(types.DELETE_ORDERS, deleteOrdersEffectSaga);
  yield takeLatest(types.GET_PENDING_ORDERS, getPendingOrdersEffectSaga);
  yield takeLatest(types.GET_PACKED_ORDERS, getPackedOrdersEffectSaga);
  yield takeLatest(types.GET_SHIPPED_ORDERS, getShippedOrdersEffectSaga);
  yield takeLatest(types.GET_DELIVERY_ORDERS, getDeliveredOrdersEffectSaga);
  // yield takeLatest(types.GET_ORDERS, getCancelledOrdersEffectSaga);
  yield takeLatest(
    types.GET_ORDERS_BY_CUSTOMER_ID,
    getOrdersByCustomerIdEffectSaga
  );
  yield takeLatest(types.GET_CUSTOMER, addProductIdToWishlistEffectSaga);
  yield takeLatest(types.CREATE_ORDERS, createOrdersWithProductsEffectSaga);
  yield takeLatest(
    types.GET_ORDERS_BY_BUNDLE_ID,
    getOrdersByCartBundleIdEffectSaga
  );
  yield takeLatest(types.GET_TOTAL_SALES, getTotalSalesEffectSaga);
  yield takeLatest(types.GET_TOTAL_ORDERS, getTotalOrdersEffectSaga);
  yield takeLatest(types.GET_PENDING_COUNT, getPendingCountEffectSaga);
  yield takeLatest(types.GET_CANCELLED_COUNT, getCancelledCountEffectSaga);
  yield takeLatest(types.GET_SHIPPED_COUNT, getShippedCountEffectSaga);
  yield takeLatest(types.GET_PACKED_COUNT, getPackedCountEffectSaga);
  yield takeLatest(types.GET_DELIVERED_COUNT, getDeliveredCountEffectSaga);
  yield takeLatest(
    types.GET_CART_BUNDLE_ID_ORDERS,
    getCartBundleIdOrdersEffectSaga
  );
  yield takeLatest(
    types.GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY,
    getCustomersTotalOrdersQuantityEffectSaga
  );
  yield takeLatest(
    types.GET_ALL_ORDERS_BY_CARTBUNDLEID,
    getAllOrdersByCartBundleIdEffectSaga
  );

  yield takeLatest(
    types.GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES,
    getAllCompletedOrdersEffectSaga
  );
  yield takeLatest(
    types.UPDATE_ORDERS_STATUS_BY_CARTBUNDLEID,
    updateOrderStatusByCartBundleIdEffectSaga
  );
}
